import script from "./InspecaoSupervisaoEstabelecimento_56B.vue?vue&type=script&setup=true&lang=js"
export * from "./InspecaoSupervisaoEstabelecimento_56B.vue?vue&type=script&setup=true&lang=js"

import "./InspecaoSupervisaoEstabelecimento_56B.vue?vue&type=style&index=0&id=c626d46a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c626d46a"]])

export default __exports__